import type { ComponentType } from "react";
import type { Pane } from "../model/types";

export type PaneComponentProps = { pane: Pane; focused: boolean };

export type PaneRegistryEntry = {
  component: ComponentType<PaneComponentProps>;
  /** Tab title; defaults to `pane.title`, then `pane.paneType`. */
  title?: (pane: Pane) => string;
  icon?: ComponentType<{ className?: string }>;
  /** Extra classes for the tab, e.g. italic for a preview tab. */
  tabClassName?: (pane: Pane) => string | undefined;
};

/** Maps `pane.paneType` to the component that renders it. Supplied by the app. */
export type PaneRegistry = Record<string, PaneRegistryEntry>;

export function paneTitle(registry: PaneRegistry, pane: Pane): string {
  return registry[pane.paneType]?.title?.(pane) ?? pane.title ?? pane.paneType;
}
